// extracted by mini-css-extract-plugin
module.exports = {"inner":"Browse_inner__1fIPz","head":"Browse_head__WBa9K","headSmall":"Browse_headSmall__pQarZ","info":"Browse_info__3rSyQ","wrapper":"Browse_wrapper__3XqSd"};